import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownToggle } from 'reactstrap';
import styled from 'styled-components';

import { APIConfig } from 'src/config';
import { carbonLabel } from 'src/enosikit/components/Chart/helpers/common';
import LinkInI18nBlock from 'src/enosikit/components/LinkInI18nBlock';
import FlashesStore from 'src/stores/FlashesStore';
import {
  INHIBIT_CARBON_DATA_VIEWS, SOURCE_HISTORIAN,
  UNIT, UNIT_CARBON, UNIT_CURRENCY, UNIT_ENERGY,
} from 'src/util/constants';

export const ViewWrapper = styled(DropdownToggle)`
{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
`;

/**
 * Provides the input for the chart display (carbon/currency/wh) type selector
 * @param {string} unit
 * @param {string} source
 * @param {boolean} isPortfolio - Carbon view is disabled for portfolio (release 1)
 * @returns {Array<object>} - chart display control options.
 */
export const controlOptionFunc = (unit, source, isPortfolio) => {
  const inhibitCarbonDataViews = APIConfig().feature(INHIBIT_CARBON_DATA_VIEWS);
  const unitOps = {
    group: UNIT,
    items: [{
      value: UNIT_ENERGY, label: 'Wh', active: (unit === UNIT_ENERGY), disabled: false,
    }, {
      value: UNIT_CURRENCY, label: <FormattedMessage id="dashboard_control.helpers.common.type_selector.currency.label" defaultMessage="$" />, active: (unit === UNIT_CURRENCY), disabled: (source === SOURCE_HISTORIAN),
    }],
  };
  if (inhibitCarbonDataViews || isPortfolio) {
    return [unitOps];
  }

  const carbonController = {
    value: UNIT_CARBON, label: carbonLabel(), active: (unit === UNIT_CARBON),
  };
  unitOps.items.push(carbonController);
  return [unitOps];
};

/**
 * @constant
 * @type {number}
 * @default
 */
export const WARNING_TIMEOUT = 5000;

/**
 * @param {import('react-intl').IntlShape} intl - i18n
 * @returns {React.ReactComponentElement} - warning dialog fragment
 */
export const warningDialog = (intl) => {
  const msgWarning = (
    <FormattedMessage
      id="helpers.dashboard.trade_rules.message_warning"
      defaultMessage="Hi! Are you trying to view your trade rules? Create and manage them by selecting Trade Rules in the menu above."
      values={{
        link: (chunks) => (
          <LinkInI18nBlock
            url={intl.formatMessage({ id: 'helpers.dashboard.trade_rules.message_warning.url', defaultMessage: 'helpers.dashboard.trade_rules.message_warning.url' })}
            urlKey="helpers.dashboard.trade_rules.message_warning.url"
            chunks={chunks}
          />
        ),
      }}
    />
  );
  return (
    <>
      <FontAwesomeIcon className="me-1" size="lg" icon={faTriangleExclamation} />
      {msgWarning}
    </>
  );
};

/**
 * Creates the warning dialog when the user in dashboard trades view
 * clicks on trades toggle button more than once in 5s
 * @param {import('react-intl').IntlShape} intl - i18n
 * @returns {void}
 */
export const showTradeRuleMsg = (intl) => {
  clearTimeout(undefined);

  const tradeRulesNav = document.querySelectorAll('nav.navbar .nav-item.nav-trade-rules');

  if (tradeRulesNav && tradeRulesNav[0]) {
    FlashesStore.flash(
      FlashesStore.WARNING,
      warningDialog(intl),
    );
    tradeRulesNav[0].classList?.add('trade-rules-highlight');
    tradeRulesNav[0].focus();
    setTimeout(() => {
      tradeRulesNav[0].classList?.remove('trade-rules-highlight');
      FlashesStore.reset();
    }, WARNING_TIMEOUT);
  }
};
